import { Grid, Box } from '@mui/material';
import { LogoAnchor, LogoHeader, MenuItem, TopMenu } from './common';
import MenuIcon from '../../../icons/Menu2';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

const HeaderWrapper = styled(Box)<{ isPrivacyPage?: boolean }>`
  background-color: ${props => props.isPrivacyPage ? '#2655E3' : 'transparent'};
  width: 100%;
`;

const HeaderGrid = styled(Grid)`
  height: 100px;

  ${props => props.theme.breakpoints.up('md')} {
    background-color: inherit;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Header = ({ setDrawerState }) => {
  const location = useLocation();
  const isPrivacyPage = location.pathname.includes('/privacy-policy') || location.pathname.includes('/privacy');

  return (
    <HeaderWrapper isPrivacyPage={isPrivacyPage}>
      <header>
        <HeaderGrid pb={2} pt={2} pl={2.5} pr={2.5} container spacing={{ xs: 0 }}
                    justifyContent={'space-between'}
                    maxWidth={1440}
                    alignItems={'center'}>
          <Grid item>
          <LogoAnchor href={'/'}>
                  <LogoHeader src="/logo/PIXELS_white_logo.png" alt="Pixels Logo" />
                </LogoAnchor>
          </Grid>
          <Grid item>
            <MenuIcon onClick={() => setDrawerState(true)}/>
            <TopMenu>
              <MenuItem><a href={'/login/'}><strong>Login</strong></a></MenuItem>
            </TopMenu>
          </Grid>
        </HeaderGrid>
      </header>
    </HeaderWrapper>
  );
};

export default Header;